define.alias("shared/components/shared/ui/profile-color-option", "settings/components/shared/ui/profile-color-option");